<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<h2 class="hd_section" id="_idParaDest-3"></h2>
<p class="DED">To my students, both past and present</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781789742671_EPUB2.vue?6ef6311b